import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../helper/Countdown';
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function

const ProductDetailsOne = ({ product }) => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);
    const productImages = [
        "assets/images/thumbs/product-details-thumb1.png",
        "assets/images/thumbs/product-details-thumb2.png",
        "assets/images/thumbs/product-details-thumb3.png",
        "assets/images/thumbs/product-details-thumb2.png",
    ];

    // increment & decrement
    const [quantity, setQuantity] = useState(1);
    const incrementQuantity = () => setQuantity(quantity + 1);
    const decrementQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : quantity);


    const [mainImage, setMainImage] = useState(productImages[0]);

    const settingsThumbs = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
    };
    if (!product) return <div className="text-center py-80">Loading...</div>;
    return (

        <section className="product-details py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-lg-9">
                        <div className="row gy-4">
                            <div className="col-xl-6">
                                <div className="product-details__left">
                                    <div className="product-details__thumb-slider border border-gray-100 rounded-16">
                                        <div className="">
                                            <div className="product-details__thumb flex-center h-100">
                                                <img
                                                    src={product.images?.[0]?.src}
                                                    alt={product.name}
                                                    style={{ maxWidth: "100%", borderRadius: "12px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-24">
                                        <div className="product-details__images-slider">
                                            <Slider {...settingsThumbs}>
                                                {productImages.map((image, index) => (
                                                    <div className="center max-w-120 max-h-120 h-100 flex-center border border-gray-100 rounded-16 p-8" key={index} onClick={() => setMainImage(image)}>
                                                        <img
                                                            src={product.images?.[index]?.src}
                                                            alt={product.name}
                                                            style={{ maxWidth: "100%", borderRadius: "12px" }}
                                                        />
                                                    </div>
                                                ))}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="product-details__content">
                                    <h5 className="mb-12">{product.name}</h5>
                                    <div className="flex-align flex-wrap gap-12">
                                        <div className="flex-align gap-12 flex-wrap">
                                            <div className="flex-align gap-8">
                                                {[...Array(5)].map((_, i) => (
                                                    <span
                                                        key={i}
                                                        className={`text-15 fw-medium d-flex ${i < Math.round(product.average_rating)
                                                            ? "text-warning-600"
                                                            : "text-gray-300"
                                                            }`}
                                                    >
                                                        <i className="ph-fill ph-star" />
                                                    </span>
                                                ))}
                                            </div>

                                            <span className="text-sm fw-medium text-neutral-600">
                                                {product.average_rating} Star Rating
                                            </span>

                                            <span className="text-sm fw-medium text-gray-500">
                                                ({product.rating_count})
                                            </span>
                                        </div>

                                        <span className="text-sm fw-medium text-gray-500">|</span>

                                        <span className="text-gray-900">
                                            <span className="text-gray-400">SKU:</span>{" "}
                                            {product.sku || "N/A"}
                                        </span>
                                    </div>

                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />

                                    <p
                                        className="text-gray-700"
                                        dangerouslySetInnerHTML={{
                                            __html: (product.description || "No description available.")
                                                .replace(/<[^>]+>/g, "") // remove HTML tags
                                                .slice(0, 120) + "..."
                                        }}
                                    />

                                    <div className="mt-32 flex-align flex-wrap gap-32">
                                        <div className="flex-align gap-8">
                                            <h4 className="mb-0">₹{product.price}</h4>

                                            {product.regular_price && product.regular_price !== product.price && (
                                                <span className="text-md text-gray-500 text-decoration-line-through">
                                                    ₹{product.regular_price}
                                                </span>
                                            )}
                                        </div>

                                        
                                    </div>

                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                    <div className="flex-align flex-wrap gap-16  rounded-8 py-16 px-24" style={{background:"#d7f2e8"}}>
                                        <div className="flex-align gap-16">
                                            <span className="text-main-600 text-sm">Special Offer:</span>
                                        </div>
                                        <div className="countdown" id="countdown11">
                                            <ul className="countdown-list flex-align flex-wrap">
                                                <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                    {timeLeft.days} <span className="days" />
                                                </li>
                                                <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                    {timeLeft.hours}<span className="hours" />
                                                </li>
                                                <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                    {timeLeft.minutes}<span className="minutes" />
                                                </li>
                                                <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                    {timeLeft.seconds}<span className="seconds" />
                                                </li>
                                            </ul>
                                        </div>
                                        <span className="text-gray-900 text-xs">
                                            Remains untill the end of the offer
                                        </span>
                                    </div>
                                    {product.stock_status === "instock" && product.stock_quantity !== null && (
                                        <div className="mb-24">
                                            <div className="mt-32 flex-align gap-12 mb-16">
                                                <span className="w-32 h-32 bg-white flex-center rounded-circle text-main-600 box-shadow-xl">
                                                    <i className="ph-fill ph-lightning" />
                                                </span>

                                                <h6 className="text-md mb-0 fw-bold text-gray-900">
                                                    {product.stock_quantity <= 10
                                                        ? "Hurry! Almost sold out"
                                                        : "Product is in stock"}
                                                </h6>
                                            </div>

                                            {/* Progress Bar */}
                                            <div
                                                className="progress w-100 bg-gray-100 rounded-pill h-8"
                                                role="progressbar"
                                                aria-valuenow={Math.min(product.stock_quantity, 100)}
                                                aria-valuemin={0}
                                                aria-valuemax={100}
                                            >
                                                <div
                                                    className="progress-bar bg-main-two-600 rounded-pill"
                                                    style={{
                                                        width: `${Math.min(product.stock_quantity, 100)}%`,
                                                    }}
                                                />
                                            </div>

                                            <span className="text-sm text-gray-700 mt-8">
                                                Available only: {product.stock_quantity}
                                            </span>
                                        </div>
                                    )}

                                    <span className="text-gray-900 d-block mb-8">Quantity:</span>
                                    <div className="flex-between gap-16 flex-wrap">
                                        <div className="flex-align flex-wrap gap-16">
                                            <div className="border border-gray-100 rounded-pill py-9 px-16 flex-align">
                                                <button onClick={decrementQuantity}
                                                    type="button"
                                                    className="quantity__minus p-4 text-gray-700 hover-text-main-600 flex-center"
                                                >
                                                    <i className="ph ph-minus" />
                                                </button>
                                                <input
                                                    type="number"
                                                    className="quantity__input border-0 text-center w-32"
                                                    value={quantity} readOnly
                                                />
                                                <button onClick={incrementQuantity}
                                                    type="button"
                                                    className="quantity__plus p-4 text-gray-700 hover-text-main-600 flex-center"
                                                >
                                                    <i className="ph ph-plus" />
                                                </button>
                                            </div>
                                            <button
                                             onClick={() => handleAddToCart(product.id)}
                                                to="#"
                                                className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48"
                                            >
                                                {" "}
                                                <i className="ph ph-shopping-cart" /> Add To Cart
                                            </button>
                                           
                                        </div>
                                       
                                    </div>
                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                    {product.on_sale && (
                                        <>
                                            <div className="flex-between gap-16 p-12 border border-main-two-600 border-dashed rounded-8 mb-16">
                                                <div className="flex-align gap-12">
                                                    <button
                                                        type="button"
                                                        className="w-18 h-18 flex-center border border-gray-900 text-xs rounded-circle hover-bg-gray-100"
                                                    >
                                                        <i className="ph ph-plus" />
                                                    </button>

                                                    <span className="text-gray-900 fw-medium text-xs">
                                                        Save ₹{product.regular_price - product.sale_price} on this product
                                                    </span>
                                                </div>

                                                <Link
                                                    to="/cart"
                                                    className="text-xs fw-semibold text-main-two-600 text-decoration-underline hover-text-main-two-700"
                                                >
                                                    View Details
                                                </Link>
                                            </div>

                                            <ul className="list-inside ms-12">
                                                <li className="text-gray-900 text-sm mb-8">
                                                    On Sale: ₹{product.sale_price} (was ₹{product.regular_price})
                                                </li>
                                                <li className="text-gray-900 text-sm mb-0">
                                                    Limited time deal on this product
                                                </li>
                                            </ul>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="product-details__sidebar border border-gray-100 rounded-16 overflow-hidden">
                            <div className="p-24">
                                <div className="flex-between bg-main-600 rounded-pill p-8">
                                    <div className="flex-align gap-8">
                                        <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
                                            <i className="ph ph-storefront" />
                                        </span>
                                        <span className="text-white">by Marketpro</span>
                                    </div>
                                    <Link
                                        to="/shop"
                                        className="btn btn-white rounded-pill text-uppercase"
                                    >
                                        View Store
                                    </Link>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100" style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-truck" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Fast Delivery</h6>
                                    <p className="text-gray-700">
                                        Lightning-fast shipping, guaranteed.
                                    </p>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100"style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-arrow-u-up-left" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Free 90-day returns</h6>
                                    <p className="text-gray-700">Shop risk-free with easy returns.</p>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100"style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-check-circle" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">
                                        Pickup available at Shop location
                                    </h6>
                                    <p className="text-gray-700">Usually ready in 24 hours</p>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100"style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-credit-card" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Payment</h6>
                                    <p className="text-gray-700">
                                        Payment upon receipt of goods, Payment by card in the
                                        department, Google Pay, Online card.
                                    </p>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100" style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-check-circle" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Warranty</h6>
                                    <p className="text-gray-700">
                                        The Consumer Protection Act does not provide for the return of
                                        this product of proper quality.
                                    </p>
                                </div>
                            </div>
                            <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100" style={{background:"#d7f2e8"}}>
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-package" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Packaging</h6>
                                    <p className="text-gray-700">
                                        Research &amp; development value proposition graphical user
                                        interface investor.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pt-80">
                    <div className="product-dContent border rounded-24">
                        <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-16">
                            <ul className="nav common-tab nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        id="pills-description-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-description"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-description"
                                        aria-selected="true"
                                    >
                                        Description
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="pills-reviews-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-reviews"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-reviews"
                                        aria-selected="false"
                                    >
                                        Reviews
                                    </button>
                                </li>
                            </ul>
                            <Link
                                to="#"
                                className="btn  rounded-16 flex-align gap-8 text-main-600 hover-bg-main-600 hover-text-white" style={{background:"#d7f2e8"}}
                            >
                                <img src="assets/images/icon/satisfaction-icon.png" alt="" />
                                100% Satisfaction Guaranteed
                            </Link>
                        </div>

                        <div className="product-dContent__box">
                            <div className="tab-content" id="pills-tabContent">
                                {/* Description Tab */}
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-description"
                                    role="tabpanel"
                                    aria-labelledby="pills-description-tab"
                                    tabIndex={0}
                                >
                                    <div className="mb-40">
                                        <h6 className="mb-24">Product Description</h6>
                                        <div dangerouslySetInnerHTML={{ __html: product.description }} />
                                    </div>

                                    <div className="mb-40">
                                        <h6 className="mb-24">Short Description</h6>
                                        <div dangerouslySetInnerHTML={{ __html: product.short_description || "N/A" }} />
                                    </div>

                                    <div className="mb-40">
                                        <h6 className="mb-24">Product Details</h6>
                                        <ul className="mt-32">
                                            {product.attributes.map((attr, i) => (
                                                <li key={i} className="text-gray-400 mb-14 flex-align gap-14">
                                                    <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                        <i className="ph ph-check" />
                                                    </span>
                                                    <span className="text-heading fw-medium">
                                                        {attr.name}:{" "}
                                                        <span className="text-gray-500">{attr.options.join(", ")}</span>
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                {/* Reviews Tab */}
                                <div
                                    className="tab-pane fade"
                                    id="pills-reviews"
                                    role="tabpanel"
                                    aria-labelledby="pills-reviews-tab"
                                    tabIndex={0}
                                >
                                    <div className="row g-4">
                                        <div className="col-lg-6">
                                            <h6 className="mb-24">Customer Reviews</h6>
                                            {product.rating_count > 0 ? (
                                                <p>{product.rating_count} reviews, Average Rating: {product.average_rating}</p>
                                            ) : (
                                                <p>No reviews yet.</p>
                                            )}
                                            {/* Optional: you can map through product reviews array here if available */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

    )
}

export default ProductDetailsOne